import '@fancyapps/fancybox/dist/jquery.fancybox.js';



// WEBPACK FOOTER //
// ./scripts/autoload/_fancybox.js